/**
 * Notification type to icon mapping
 * Maps notification types to Font Awesome icon classes
 */
export const notificationIcons = {
  'content-claim': 'fas fa-file-alt',
  'content-claim-created': 'fas fa-file-alt',
  'content-claim-accepted': 'fas fa-check-circle',
  'content-claim-rejected': 'fas fa-times-circle',
  // Add more notification types and their icons here
};

/**
 * Get the icon class for a notification type
 * @param {string} type - The notification type
 * @returns {string} - The Font Awesome icon class
 */
export const getNotificationIcon = (type) => {
  if (!type) {
    return 'fas fa-bell'; // Default notification icon
  }
  // Check if type exists in dictionary
  if (notificationIcons[type]) {
    return notificationIcons[type];
  }
  // Default icon for unknown types
  return 'fas fa-bell';
};

